import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { LgaProfile, stateEdit, StateProfile, states, StatesWithLGA, StateWithLGAResponse } from "./interface";


interface initialState{
 edit:stateEdit
 states:states[]|null;
 LPState:"state"|"LGA";
 stateLGA:LgaProfile[]|null
 lgaProfile:LgaProfile|null;
 stateProfile:StateProfile[]|null;
 statesWithLGA:StatesWithLGA|null;
 StateWithLGAResponse:StateWithLGAResponse|null
}
const initialState:initialState ={
 edit: {
    edit:false,
 },
 states:null,
 stateLGA:null,
 LPState:"state",
 lgaProfile:null,
 stateProfile:null,
 statesWithLGA:null,
 StateWithLGAResponse:null
}

const LocationProfileSlice = createSlice({
    name:"location-profile",
    initialState,
    reducers:{
        setStateEdit:(state:initialState, action:PayloadAction<stateEdit>)=>{
            state.edit = action.payload
        },
        setStates:(state:initialState, action:PayloadAction<states[]>)=>{
            state.states = action.payload
        },
        setLPAState:(state:initialState, action:PayloadAction<"state"|"LGA">)=>{
            state.LPState = action.payload
        },
        setStateLGA:(state:initialState, action:PayloadAction<LgaProfile[]>)=>{
            state.stateLGA = action.payload
        },
        setStateProfile:(state:initialState, action:PayloadAction<StateProfile[]>)=>{
            state.stateProfile = action.payload
        },
        setLGAProfile:(state:initialState, action:PayloadAction<LgaProfile|null>)=>{
            state.lgaProfile = action.payload
        },
        setStatesWithLGA:(state:initialState, action:PayloadAction<StatesWithLGA>)=>{
            state.statesWithLGA = action.payload
        },
        setStateWithLGAResponse:(state:initialState, action:PayloadAction<StateWithLGAResponse>)=>{
            state.StateWithLGAResponse = action.payload
        }
    }
    
})


export default LocationProfileSlice
export const {
    setStates,
    setLPAState,
    setStateLGA,
    setStateEdit,
    setLGAProfile,
    setStateProfile,
    setStatesWithLGA,
    setStateWithLGAResponse
} = LocationProfileSlice.actions